/**
 * Dial time for the power dialer and multi-line. Placing and being on calls counts in full, each
 * gap between calls counts up to IDLE_CAP_MS (wrap-up is work, a panel left open is not), a pause
 * counts nothing. Same 2-minute bound as the agency dashboard's "On the dialer".
 */
const openMs = (clock: DialClock, now: number) => {
  const elapsed = Math.max(0, now - clock.since);
  if (clock.mode === "busy") return elapsed;
  return clock.mode === "idle" ? Math.min(elapsed, IDLE_CAP_MS) : 0;
};

export type DialClockMode = "busy" | "idle" | "paused";

export const IDLE_CAP_MS = 2 * 60 * 1000;

export interface DialClock {
  countedMs: number;
  mode: DialClockMode;
  since: number;
}

export const startDialClock = (now: number): DialClock => ({ countedMs: 0, mode: "idle", since: now });

/** Closes the running stretch and opens one in `mode`. Same mode is a no-op. */
export const switchDialClock = (clock: DialClock, mode: DialClockMode, now: number): DialClock =>
  mode === clock.mode ? clock : { countedMs: clock.countedMs + openMs(clock, now), mode, since: now };

export const dialClockSeconds = (clock: DialClock, now: number): number =>
  Math.floor((clock.countedMs + openMs(clock, now)) / 1000);
